import React, { useEffect,useLayoutEffect, useRef, useState } from "react";

import {
  generateSilentTokenIfExpired,
  getRefreshTokenIfOtpLoginTokenExpires,
  handleLogout,
  isOTPTokenExpired,
  isTokenExpired,
  logoutUserIfExpired
} from "../../tokenUtils";
import "../tokenexpiration/TokenExpirationHandlerPopup.css";
import { OTP_LOGIN, RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN, USER_LOGIN_SESSIONID } from "../../Configuration";

const TokenExpirationHandler = (): React.JSX.Element | null => {
  const [showPopup, setShowPopup] = useState(false);
  const [isLoaderActive, setIsLoaderActive] = useState(false);

  const idleTimeout = 49 * 60 * 1000  // 1 min for testing, change to 49 * 60 * 1000

  const timerRef = useRef<NodeJS.Timeout | null>(null);


const validateIdleTimeout = () => {
  const saved = localStorage.getItem("user-activity");

  if (!saved) {
    console.error("No user activity recorded");
    return;
  }

  const lastActivity = parseInt(saved, 10);

  if (isNaN(lastActivity)) {
    console.error("Invalid last activity timestamp");
    return;
  }

  const elapsed = Date.now() - lastActivity;

  if (elapsed >= idleTimeout) {
     setShowPopup(true);
    return;
  }

};

  const resetIdleTimer = () => {
    const useractivity = localStorage.getItem("user-activity");

    if (timerRef.current) clearTimeout(timerRef.current);
    validateIdleTimeout()
    timerRef.current = setTimeout(() => {
      setShowPopup(true);
      localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
      localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
    }, idleTimeout);

    localStorage.setItem("user-activity", Date.now().toString());
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetIdleTimer));

    const onStorage = (e: StorageEvent) => {
      if (e.key === "user-activity") {
        if (timerRef.current) clearTimeout(timerRef.current);
         timerRef.current = setTimeout(() => {
          setShowPopup(true);
          localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
          localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
          localStorage.removeItem(USER_LOGIN_SESSIONID);
        }, idleTimeout);
      }
    };
    window.addEventListener("storage", onStorage);

    resetIdleTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      window.removeEventListener("storage", onStorage);
    };
  }, [idleTimeout]);

  const isotpToken = localStorage.getItem(OTP_LOGIN);
  useEffect(() => {
    const tokenCheck = setInterval(async () => {
        if(isotpToken === 'true'){
      if(await isOTPTokenExpired())
          getRefreshTokenIfOtpLoginTokenExpires()
       }
       else{
        if(await isTokenExpired())
            generateSilentTokenIfExpired()
       }

     }, 1000);

    return () => clearInterval(tokenCheck);
  }, []);

   useLayoutEffect(() => {
    if (!showPopup) return;
    const checkLoader = () => setIsLoaderActive(!!document.getElementById("pageoverlay"));
    checkLoader();
    const observer = new MutationObserver(checkLoader);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [showPopup]);

  const handleLogoutBnt = () => {
    setShowPopup(false);
     if(isotpToken === 'true'){
      handleLogout()
       }
       else{
      logoutUserIfExpired();
    }
  };

  return showPopup && !isLoaderActive ? (
    <>
    <div className="token-expiry-popup-overlay submit-bg">
      <div className="token-expiry-popup">
        <h2 tabIndex={0} aria-label="Session Expired" className="mb-2">Session Expired</h2>
        <p tabIndex={0} aria-label="You have been inactive or your token has expired. Please log in again.">You have been inactive or your token has expired. Please log in again.</p>
        <button onClick={handleLogoutBnt}>Okay</button>
      </div>
    </div>
    </>
  ) : null;
};

export default TokenExpirationHandler
